import { render, staticRenderFns } from "./QuantityPrice.vue?vue&type=template&id=5d20086f&"
import script from "./QuantityPrice.vue?vue&type=script&lang=js&"
export * from "./QuantityPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports